import { DeepPartial, AppConfig } from "../../../../src/app/interfaces/app-config";

export const projectConfig: DeepPartial<AppConfig> = {
  // Ejemplo
  pages: {
    login: {
      title: 'Iniciar sesión',
    },
    users: {
      titlePlural: 'Usuarios',
      titleSingular: 'Usuario',
      form: {
        name: {
          label: 'Nombres y Apellidos',
          placeholder: 'Ingresa tu nombre completo'
        },
        email: {
          label: 'Correo electrónico',
          placeholder: 'Ingresa tu correo electrónico'
        },
        password: {
          label: 'Contraseña',
          placeholder: 'Ingresa tu contraseña'
        },
        image: {
          label: 'Imagen',
          placeholder: 'Selecciona una imagen'
        },
        rol: {
          label: 'Asignar rol',
          placeholder: 'Selecciona....'
        },

      },
      form_filter:{
        name: {
          label: 'Nombres y Apellidos',
          placeholder: 'Ingresa tu nombre completo'
        },
        email: {
          label: 'Correo electrónico',
          placeholder: 'Ingresa tu correo electrónico'
        },
      },
    },
    agency: {
      titlePlural: 'Agencias',
      titleSingular: 'Agencia',
      form: {
        name: {
          label: 'Nombre de la agencia ',
          placeholder: 'Ingresa tu nombre..'
        },
        address: {
          label: 'Dirección',
          placeholder: 'Ingresa dirección...'
        },
        phone: {
          label: 'Telefono',
          placeholder: 'Ingresa telefono...'
        },
        business: {
          label: 'Empresa',
          placeholder: 'Ingresa nombre de empresa...'
        },
        latitude: {
          label: 'Latitude',
          placeholder: 'Latitude....'
        },
        longitude: {
          label: 'Longitude',
          placeholder: 'Longitude....'
        },
        description: {
          label: 'Descripción',
          placeholder: 'Ingresa descripción....'
        }
      },
      form_filter:{
        name: {
          label: 'Nombres y Apellidos',
          placeholder: 'Ingresa tu nombre completo'
        },
        email: {
          label: 'Correo electrónico',
          placeholder: 'Ingresa tu correo electrónico'
        },
      }

    },
    customer: {
      titlePlural: 'Conductores',
      titleSingular: 'Conductor',
      form: {
        name: {
          label: 'Nombres y Apellidos',
          placeholder: 'Ingresa tu nombre completo'
        },
        cellphone: {
          label: 'Celular',
          placeholder: 'Ingresa tu número de celular'
        },
        email:null,
        code: {
          label: 'Contraseña',
          placeholder: 'Ingresa contraseña'
        },
      },
      form_filter:{
        name: {
          label: 'Nombres y Apellidos',
          placeholder: 'Ingresa tu nombre completo'
        },
        email: {},
        cellphone: {
          label: 'Celular',
          placeholder: 'Ingresa tu número de celular'
        },
        initial_date: {
          label: 'Fecha inicio',
          placeholder: 'Ingresa fecha inicio'
        },
        end_date: {
          label: 'Fecha fin',
          placeholder: 'Ingresa fecha fin'
        },
      }
    },
    transactions: {
      titlePlural: 'Tickets',
      titleSingular: 'Tickets',
      form:{
        payment_method_id: null ,
        user_id: null,
        ci_number: {
          label: 'Numero de licencia',
          placeholder: 'Escribir...'
        },
        email: null,
        cellphone: {
          label: 'Teléfono',
          placeholder: 'Escribir...'
        },
        status: {
          label: 'Estado',
          placeholder: 'Seleccionar...'
        },
        created_at_from: {
          label: 'Fecha de creación (Desde)',
          placeholder: 'Seleccionar...'
        },
        created_at_to: {
          label: 'Fecha de creación (Hasta)',
          placeholder: 'Seleccionar...'
        },
        extra_transsaction: {
          label: 'Cod. externo de transacción',
          placeholder: 'Escribir...'
        },
        name: {
          label: 'Usuario',
          placeholder: 'Escribir...'
        }
      }
    },
    vehicles: {
      titlePlural: 'Tickets',
      titleSingular: 'Ticket',
      form:{},
    },

    profile: {
      titlePlural: 'Vehiculos',
      titleSingular: 'Vehiculo',
      form:{
        name: {
          label: 'Nombre',
          placeholder: 'Escribir nombre'
        },
        last_name: {
          label: 'Apellido',
          placeholder: 'Escribir apellido...'
        },
        email: {
          label: 'Correo electrónico',
          placeholder: 'Escribir correo electrónico...'
        },
        cellphone: {
          label: 'Celular',
          placeholder: 'Escribir celular...'
        },
        birth_date: {
          label: 'Fecha de nacimiento',
          placeholder: 'Escribir Fecha de nacimiento...'
        },
        city: {
          label: 'Ciudad',
          placeholder: 'Escribir ciudad...'
        },
        country: {
          label: 'País',
          placeholder: 'Escribir paós...'
        },
        ci:{
          label: 'Carnet',
          placeholder: 'Ingrese...'
        },
      },
      form_filter: {
        name:{
          label: 'Nombre',
          placeholder: 'Escribir nombre'
        },
        lastName:{
          label: 'Apellido',
          placeholder: 'Escribir apellido'
        },
        email:{
          label: 'Correo electrónico',
          placeholder: 'Escribir correo electrónico'
        },
        numberCi:{
          label: 'Numero de carnet',
          placeholder: 'Escribir numero carnet'
        },
        initial_date:{
          label: 'Fecha inicio',
          placeholder: 'Escribir...'
        },
        end_date:{
          label: 'Fecha fin',
          placeholder: 'Escribir...'
        },
        city:{
          label: 'Ciudad',
          placeholder: 'Escribir...'
        },
        event:{
          label: 'Eventos',
          placeholder: 'Seleccionar...'
        },

      }
    },

  },

  menu: [
    {
      headTitle1: "General",
      permissions:'default',
    },
    {
      id: 1,
      level: 1,
      path: '/account',
      title: "Mi Cuenta",
      icon: "home",
      type: "link",
      permissions:'default',
    },

    {
      headTitle1: "Usuarios",
      //permissions:'organization-title-user',
      permissions:'default',
    },
    {
      id: 2,
      level: 1,
      path: '/users',
      title: "Usuarios del admin",
      icon: "bookmark",
      type: "link",
      permissions:'organization-page-users',
    },
    {
      id: 3,
      level: 1,
      path: '/profile',
      title: "Vehiculos",
      icon: "bookmark",
      type: "link",
      permissions:'organization-page-profiles',
    },
    {
      id: 4,
      level: 1,
      path: '/customer',
      title: "Conductores",
      icon: "bookmark",
      type: "link",
      permissions:'organization-page-customers',
    },
    {
      id: 5,
      level: 1,
      path: '/brands',
      title: "Marca",
      icon: "bookmark",
      type: "link",
      permissions:'default',
    },
    {
      id: 6,
      level: 1,
      path: '/brands-model',
      title: "Modelo",
      icon: "bookmark",
      type: "link",
      permissions:'default',
    },
    {
      id: 7,
      level: 1,
      path: '/kpis',
      title: "KPIs",
      icon: "bookmark",
      type: "link",
      permissions:'default',
    },
    {
      id: 8,
      level: 1,
      path: '/loyalty-management',
      title: "Tarjetas de lealtad",
      icon: "bookmark",
      type: "link",
      permissions:'default',
    },
    {
      headTitle1: "Soporte",
      permissions: 'default',
    },
    // {
    //   id: 3,
    //   level: 1,
    //   path: 'transactions',
    //   title: "Tickets",
    //   icon: "bookmark",
    //   type: "link",
    //   permissions:'default',
    // },
    {
      id: 1,
      level: 1,
      path: '/vehicles',
      title: "Tickets",
      icon: "bookmark",
      type: "link",
      permissions:'default',
    },

  ],

  firebaseKeyMessage: 'BB_kuPdlC91dvIIFlYGE3TEMidqV51uqcGhIpv47GbxmeqSRln2Ei5en1NC_33tOA2kgG00FaxIG2Z0Gt8NH0qc',
  firebase: {
    apiKey: "AIzaSyAjTCOWnENWgXHmFp2ZMFQ9knynxT9lGsQ",
    authDomain: "redi-bolivia.firebaseapp.com",
    projectId: "redi-bolivia",
    storageBucket: "redi-bolivia.firebasestorage.app",
    messagingSenderId: "961399504555",
    appId: "1:961399504555:web:d6c33ae13f566f2d1f81ee",
    measurementId: "G-YL03E415HQ"
  }
};
